import UploadSuccessStep from './UploadSuccessStep';

export default UploadSuccessStep;
